<template>
  <div
    v-if="videoId"
    class="video-section"
  >
    <video-centered v-bind:video-id="videoId"></video-centered>
  </div>
</template>

<script>
import { getIdFromUrl } from 'vue-youtube'
import VideoCentered from '../utils/VideoCentered'

export default {
  name: 'CatalogJewelArticleVideo',
  props: ['jewel'],
  components: {VideoCentered},
  data: function () {
    return {}
  },
  computed: {
    videoId: function () {
      return this.jewel.video_url ? getIdFromUrl(this.jewel.video_url) : ''
    }
  }
}
</script>

<style scoped lang="scss">
  .video-section {
    @include vertical-breakpoint-padding("tablet", 3em, 2em);
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-jewel-article/CatalogJewelArticleVideo.vue